<template>
  <div class="edu_pages">
    <div class="edu_pages_content_box">
      <div class="edu_page_title_box">
        <div class="title_box">
          <div class="color_lump_box"></div>
          <span>评分规则</span>
        </div>
      </div>
      <div class="edu_pages_content_body_box">
        <div class="edu_table_box rules_table_box" >
          <el-table
            :data="tableData"
            height="100%"
            border
            :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
            class="table_box"
            :span-method="objectSpanMethod"
          >
            <el-table-column
              label="指标类型"
              align="center"
              prop="indicatorType"
              width="160"
            ></el-table-column>
            <el-table-column
              label="指标描述"
              align="center"
              prop="indexDescription"
              width="200"
            ></el-table-column>
            <el-table-column
              label="具体细则"
              align="center"
              prop="detailedRules"
              width="350"
            ></el-table-column>
            <el-table-column label="计分规则" align="center">
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  type="primary"
                  @click="editRulesInfo(scope.$index)"
                  v-if="$store.getters.getEduData.eduBuresuType == 0"
                >
                  <regular-sub :item="scope.row"></regular-sub>
                </el-link>
                <span v-else>
                  <regular-sub :item="scope.row"></regular-sub>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="最高分值" align="center" width="160">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.scoringRangeEnd == '-1' &&
                      scope.row.maxScore == '-1' &&
                      scope.row.scoringType == '0'
                  "
                >
                  不限
                </span>
                <span v-else>{{ scope.row.maxScore }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :append-to-body="false"
      title="计分规则修改"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <!-- <el-form :model="editInfo" label-width="140px">
        <el-form-item
          v-if="rowIndex != 5 && rowIndex != 14 && rowIndex != 21"
          label="计分类型："
          prop="scoringType"
        >
          <el-radio-group size="small" v-model="editInfo.scoringType">
            <el-radio :label="0">可累加</el-radio>
            <el-radio :label="1">不累加</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="项目分值：" prop="score">
          <el-input size="small" clearable v-model.trim="editInfo.score">
            <template slot="append">分</template>
          </el-input>
          <span
            style="color:#979898;"
            v-if="rowIndex == 5 || rowIndex == 14 || rowIndex == 21"
          >
            说明：按学校完成率计分，实际得分=完成率*项目分值；<br />
            举例：若学校完成率为90%，项目分值为10分，则实际学校得分为9分（90%*10=9分）。
          </span>
        </el-form-item>
        <el-form-item
          v-if="rowIndex != 5 && rowIndex != 14 && rowIndex != 21"
          label="设置计分范围："
        >
          <div>
            <el-radio
              v-model="editInfo.scoringRangeStart"
              :label="editInfo.scoringRangeStart"
              >从第
              <el-input
                v-model.trim="editInfo.scoringRangeStart"
                size="small"
                style="width:100px"
              ></el-input>
              条开始累加</el-radio
            >
          </div>
          <el-checkbox v-model="checkbox" v-if="editInfo.scoringType == 0"
            >从第
            <el-input
              v-model.trim="editInfo.scoringRangeEnd"
              size="small"
              style="width:100px"
            ></el-input>
            条结束累加</el-checkbox
          >
        </el-form-item>
      </el-form> -->
      <el-form :model="editInfo" label-width="140px">
        <el-form-item
          v-if="
            editInfo.calculationMethod == 0 ||
              editInfo.calculationMethod == 1 ||
              editInfo.calculationMethod == 2
          "
          label="计分类型："
          prop="scoringType"
        >
          <span v-if="editInfo.scoringType == 0">可累加</span>
          <span v-if="editInfo.scoringType == 1">不累加</span>
        </el-form-item>
        <el-form-item label="项目分值：" prop="score">
          <el-input size="small" clearable v-model.trim="editInfo.score">
            <template slot="append">分</template>
          </el-input>
          <span style="color:#979898;" v-if="editInfo.calculationMethod == 3">
            说明：按学校完成率计分，实际得分=完成率*项目分值；<br />
            举例：若学校完成率为90%，项目分值为10分，则实际学校得分为9分（90%*10=9分）。
          </span>
        </el-form-item>
        <el-form-item
          v-if="
            editInfo.calculationMethod == 0 ||
              editInfo.calculationMethod == 1 ||
              editInfo.calculationMethod == 2
          "
          label="设置计分范围："
        >
          <div>
            <el-radio
              v-model="editInfo.scoringRangeStart"
              :label="editInfo.scoringRangeStart"
              >从第
              <el-input
                v-model.trim="editInfo.scoringRangeStart"
                size="small"
                style="width:100px"
              ></el-input>
              条开始累加</el-radio
            >
          </div>
          <el-checkbox v-model="checkbox" v-if="editInfo.calculationMethod == 1"
            >从第
            <el-input
              v-model.trim="editInfo.scoringRangeEnd"
              size="small"
              style="width:100px"
            ></el-input>
            条结束累加</el-checkbox
          >
        </el-form-item>
      </el-form>
      <div class="bottom-box">
        <el-button
          size="small"
          type="primary"
          style="width:120px"
          @click="saveInfo"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import regularSub from "./components/inspectionRulesSub.vue";
export default {
  name: "inspectionRules",
  components: {
    regularSub
  },
  data() {
    return {
      tableData: [],
      rowIndex: 0,
      editInfo: {},
      dialogVisible: false,
      radio: "1",
      checkbox: true
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      let res = await this.$Http.getRulesList();
      if (res.code == 200) {
        this.tableData = res.data || [];
        // this.tableData = data.map((item, index) => {
        //   // console.log(index);
        //   if (index < 3) {
        //     //  不累加
        //     item.rules =
        //       "填写条数>=" +
        //       item.scoringRangeStart +
        //       "条时，给" +
        //       item.score +
        //       "分";
        //   } else if (index == 3 || index == 4) {
        //     item.rules = "完善信息给 " + item.score + "分";
        //   } else if (index == 14 || index == 21) {
        //     item.rules =
        //       "按完成率计分，项目分为" +
        //       item.score +
        //       "分;若巡查完成率为90%，则实际得分为90%*" +
        //       item.score +
        //       "=" +
        //       item.score * 0.9 +
        //       "分";
        //   } else {
        //     if (item.scoringType == 0) {
        //       //  可累加
        //       if (item.scoringRangeEnd == "-1") {
        //         item.rules = "每填报一条给" + item.score + "分, 可累加";
        //       } else {
        //         item.rules =
        //           "每填报一条给" +
        //           item.score +
        //           "分, 累加上限数量" +
        //           item.scoringRangeEnd;
        //       }
        //     } else {
        //       //  不累加
        //       item.rules =
        //         "填写条数>=" +
        //         item.scoringRangeStart +
        //         "条时，给" +
        //         item.score +
        //         "分";
        //     }
        //   }
        //   return item;
        // });
      } else if (res.code == 101) {
        this.tableData = [];
      } else {
        this.$message.error("列表获取失败！");
        this.tableData = [];
      }
    },
    editRulesInfo(index) {
      this.rowIndex = index;
      this.editInfo = Object.assign({}, this.tableData[index]);
      delete this.editInfo.addTime;
      delete this.editInfo.updateTime;
      this.dialogVisible = true;
      if (this.editInfo.scoringRangeEnd == -1) {
        this.checkbox = false;
      }
    },
    handleClose() {
      this.editInfo = {};
      this.dialogVisible = false;
    },
    async saveInfo() {
      if (!this.isNumber(this.editInfo.score)) {
        this.$message.error("请输入正确项目分值！");
        return;
      }
      if (!this.isNumber(this.editInfo.scoringRangeStart)) {
        this.$message.error("请输入正确开始条数！");
        return;
      }
      if (
        this.editInfo.scoringType == 0 &&
        !this.isNumber(this.editInfo.scoringRangeEnd)
      ) {
        this.$message.error("请输入正确结束条数！");
        return;
      }
      this.editInfo.scoringRangeStart = parseInt(
        this.editInfo.scoringRangeStart
      );
      this.editInfo.scoringRangeEnd =
        parseInt(this.editInfo.scoringRangeEnd) || 0;
      this.editInfo.score = parseInt(this.editInfo.score);
      if (this.editInfo.scoringType == 0 && !this.checkbox) {
        this.editInfo.scoringRangeEnd = -1;
      }
      if (this.editInfo.scoringType == 1 && !this.checkbox) {
        this.editInfo.scoringRangeEnd = 0;
      }
      if (this.editInfo.scoringType == 0 && this.checkbox) {
        if (this.editInfo.scoringRangeEnd < this.editInfo.scoringRangeStart) {
          this.$message.error("结束条数要大于开始条数！");
          return;
        }
      }
      let req = {
        id: this.editInfo.id,
        scoringType: this.editInfo.scoringType,
        score: this.editInfo.score,
        scoringRangeStart: this.editInfo.scoringRangeStart,
        scoringRangeEnd: this.editInfo.scoringRangeEnd
      }
      let res = await this.$Http.editRulesInfo(req, true);
      if (res.code == 200) {
        this.dialogVisible = false;
        this.getList();
      } else {
        this.$message.error("编辑失败！");
      }
    },
    isNumber(val) {
      //非负浮点数
      var reg = /^(([1-9]\d+(.[0-9]{1,4})?|\d(.[0-9]{1,4})?)|([-]([1-9]\d+(.[0-9]{1,4})?|\d(.[0-9]{1,4})?)))$/;
      if (reg.test(val)) {
        return true;
      } else {
        return false;
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else if (rowIndex === 4) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else if (rowIndex === 10) {
          return {
            rowspan: 8,
            colspan: 1
          };
        } else if (rowIndex === 18) {
          return {
            rowspan: 7,
            colspan: 1
          };
        } else if (rowIndex === 25) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else if (rowIndex === 29) {
          return {
            rowspan: 1,
            colspan: 1
          };
        } else if (rowIndex === 30) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (columnIndex === 1) {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else if (rowIndex === 3) {
          return {
            rowspan: 1,
            colspan: 1
          };
        } else if (rowIndex === 4) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else if (rowIndex === 8) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (rowIndex === 10) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (rowIndex === 12) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else if (rowIndex === 16) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (rowIndex === 18 || rowIndex === 19) {
          return {
            rowspan: 1,
            colspan: 1
          };
        } else if (rowIndex === 20) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (rowIndex === 22 || rowIndex === 23 || rowIndex === 24) {
          return {
            rowspan: 1,
            colspan: 1
          };
        } else if (rowIndex === 25 || rowIndex === 27) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (rowIndex === 29) {
          return {
            rowspan: 1,
            colspan: 1
          };
        } else if (rowIndex === 30) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  },
  computed: {}
};
</script>
<style scoped lang="scss">
@import "../../../../../public/css/edu_pages.scss";
.table-bordered {
  width: 100%;
  height: 100%;
}
.table-thead {
  display: table;
  width: 90%;
  margin: 0px 5%;
  height: 50px;
  background: #dde4ff;
  color: #474859;
  th {
    text-align: center;
    &:nth-child(1) {
      width: 10%;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      width: 20%;
    }
    &:nth-child(4) {
      width: 40%;
    }
    &:nth-child(5) {
      width: 10%;
    }
  }
}
.table-tbody {
  display: block;
  height: calc(100% - 50px);
  width: 90%;
  margin: 0px 5%;
  overflow-y: scroll;
  td {
    text-align: center;
    vertical-align: middle;
    &:nth-child(1) {
      width: 10%;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      width: 20%;
    }
    &:nth-child(4) {
      width: 40%;
    }
    &:nth-child(5) {
      width: 10%;
    }
  }
}
.bottom-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.rules_table_box /deep/ .el-table tbody tr:hover > td {
  background-color: #ffffff !important;
}
</style>
